<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     :style="'background-image: url('+configData.company_banner+')'">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100"
                          ref="form" data-url="/admin/users/login" action="store">

                        <div class="text-center mb-4">
                           <a href="/">
                               <img :src="configData.company_logo" alt=""
                                    class="img-fluid logo">
                           </a>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <h6 class="text-center mb-0">{{ $t('hi_there') }}</h6>
                                <label class="text-center d-block">{{ $t('log_in_to_your_dashboard') }}</label>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <label for="login_email">{{ $t('email_or_phone_number') }}</label>
                                <app-input type="text"
                                           id="login_email"
                                           v-model="login.email_phone_number"
                                           :placeholder="$t('enter_your_email_phone')"
                                           :required="true"
                                           :errormessage="$errorMessage(errors, 'email_phone_number')"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <label for="login_password">{{ $t('password') }}</label>
                                <app-input type="password"
                                           v-model="login.password"
                                           id="login_password"
                                           :placeholder="$t('enter_your_password')"
                                           :errormessage="$errorMessage(errors, 'password')"
                                           :required="true"/>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                                <app-submit-button
                                        btnClass="btn btn-primary btn-block text-center"
                                        :label="$t('login')"
                                        :loading="preloader"
                                        @click="submit"
                                />
                            </div>
                        </div>
<!--                        <div class="form-row form-row flex-column flex-md-row justify-content-center justify-content-md-between justify-content-lg-between">-->
<!--                            <a href="/forget-password"-->
<!--                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">-->
<!--                                <app-icon name="lock" class="pr-2"/>-->
<!--                                {{ $t('forgot_password') }}-->
<!--                            </a>-->
<!--                        </div>-->
                        <div class="form-row mt-3">
                            <div class="col-12 d-flex align-items-center">
                                <p>Don't have account? <a :href="signUpUrl">Sign up</a> now</p>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') + configData.company_name }}
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "Login",
        mixins: [AuthMixin, ThemeMixin],
        components: {},
        props: {
            siteKey: String,
            recaptchaEnable: {},
            redirect: {}
        },
        data() {
            return {
                login: {email_phone_number: '', password: ''},
            };
        },
        methods: {
            submit() {
                this.save(this.login);
            },
            afterSuccess(res) {
                if (Boolean(this.redirect)) {
                    return window.location = `/${this.redirect}`
                }
                window.location = res.data;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
                this.errors = res.data.errors;
                this.$nextTick(() => {
                    this.preloader = false;
                });
            },
        },
        computed: {
            signUpUrl() {
                return urlGenerator('user/sign-up')
            }
        }
    }
</script>
